import { useQueryClient } from 'react-query';

export default function useResource() {
  const queryClient = useQueryClient();
  const resources: any = queryClient.getQueryData('resources');
  return resources?.data;
}
